<template>
  <section class="expansionPanel-root">
    <section class="expansionPanel">
      <v-expansion-panels v-model="panelOpen" multiple :disabled="disabled">
        <v-expansion-panel v-for="(panel, i) in panels" :key="i">
          <v-expansion-panel-header>
            <section class="expansionPanel-header">
              <v-img
                cover
                max-height="64"
                :max-width="isMobile ? 60 : 90"
                class="expansionPanel-header_avatar"
                :src="panel.avatar"
                alt=""
              />
              <section class="expansionPanel-header-right">
                <section class="expansionPanel-header_title">
                  <h1>{{ panel.title }}</h1>
                  <h4 v-if="panel.subtitle">{{ panel.subtitle }}</h4>
                </section>
                <article>
                  <section
                    class="expansionPanel-header_verified"
                    @click.stop.prevent="
                      $emit('onAction', panel.guaranteeAction)
                    "
                  >
                    保障内容<img src="image/icon_info.svg" />
                  </section>
                  <section
                    v-if="countSelectedItems(panel) !== 0"
                    class="expansionPanel-header_selected"
                  >
                    {{ `${countSelectedItems(panel)}件選択中` }}
                  </section>
                  <section v-else class="expansionPanel-header_selected--zero">
                    未選択
                  </section>
                </article>
              </section>
            </section>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <section class="expansionPanel-content">
              <section
                v-for="(item, itemIndex) in panel.list"
                :key="itemIndex"
                class="expansionPanel-item"
              >
                <section
                  :class="[
                    'expansionPanel-item_label',
                    getItemLabelColorClass(item.label),
                  ]"
                >
                  {{ item.label }}
                </section>
                <section class="expansionPanel-item-sections">
                  <section
                    v-for="(section, sectionIndex) in item.sections"
                    :key="sectionIndex"
                    :class="[item.label === 'Z型' || item.label === 'X型' ? 'expansionPanel-item-section-row' : 'expansionPanel-item-section']"
                  >
                    <h4 class="expansionPanel-item-section_title">{{section.title}}</h4>
                    <app-select
                      v-if="section.type === 'select-money'"
                      v-model="section.value"
                      :disabled="section.disabled"
                      class="expansionPanel-item-section_select"
                      :items="section.values"
                      item-value="value"
                      item-text="text"
                      default-label="-"
                      @change="$emit('onAction', section.action)"
                    />
                    <app-select
                      v-if="section.type === 'select-custom'"
                      v-model="section.value"
                      :disabled="section.disabled"
                      class="expansionPanel-item-section_select"
                      :items="section.values"
                      item-value="value"
                      item-text="text"
                      default-label="-"
                      @change="$emit('onAction', section.action)"
                    />
                    <div
                      v-if="section.type === 'text'"
                      class="expansionPanel-item-section_text"
                    >
                      {{ section.value }}
                    </div>
                  </section>
                </section>
              </section>
            </section>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </section>
    <v-divider />
  </section>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'ExpansionPanel',
  props: {
    panels: {
      type: Array,
      default: () => [],
    },
    itemsOpen: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      panelOpen: [],
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.common.isMobile,
    }),
  },
  watch: {
    disabled(newVal) {
      if (newVal) {
        this.panelOpen = [];
      }
    },
    itemsOpen: {
      handler: function (value) {
        this.panelOpen = value;
      },
      immediate: true,
    },
  },
  methods: {
    getItemLabelColorClass(label) {
      const type = String(label || '')
        .replace(/\s+/g, '')
        .replace(/型/g, '')
        .toUpperCase();

      if (['A', 'B', 'C', 'D'].includes(type)) {
        return 'expansionPanel-item_label--abcd';
      }

      if (['E', 'J', 'K'].includes(type)) {
        return 'expansionPanel-item_label--ejk';
      }

      if (['P', 'Y', 'Z', 'X'].includes(type)) {
        return 'expansionPanel-item_label--pyzx';
      }

      if (['G', 'M', 'N'].includes(type)) {
        return 'expansionPanel-item_label--gmn';
      }

      return '';
    },
    countSelectedItems(panel) {
      return panel.list.reduce((acc, item) => {
        return (
          acc +
          item.sections.reduce((acc, section) => {
            return (
              acc +
              (section.value &&
              ['select-money', 'select-custom'].includes(section.type)
                ? 1
                : 0)
            );
          }, 0)
        );
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.expansionPanel {
  background-color: #f4f4f4;
  padding: 0 40px;

  &::v-deep .v-expansion-panel {
    &::before {
      box-shadow: none;
      border-bottom: thin solid;
    }

    &--disabled {
      background-color: #f4f4f4 !important;
      & .v-expansion-panel {
        &-header {
          &__icon {
            display: inline-flex !important;
            border-color: #ccc !important;
            .v-icon {
              color: #ccc !important;
            }
          }
        }
      }
      & .expansionPanel {
        &-header {
          &_avatar {
            filter: grayscale(100%);
          }
          &_title {
            & > h1 {
              color: #ccc;
            }
            & > h4 {
              color: #ccc;
            }
          }
          &_verified {
            color: #ccc;
            img {
              opacity: 0.6;
            }
          }
          &_selected,
          &_selected--zero {
            color: #ccc;
          }
        }
      }
    }

    &-header {
      padding: 0;
      &__icon {
        border: solid 1px #707070;
        .v-icon {
          font-size: 32px;
          color: #666;
        }
      }
    }
    &-content__wrap {
      padding: 0;
    }
    &--active:not(:first-child) {
      margin-top: 0;
      &::after {
        opacity: 1;
      }
    }
    &--active + .v-expansion-panel {
      margin-top: 0;
      &::after {
        opacity: 1;
      }
    }
  }
  &::v-deep .theme--light.v-expansion-panels .v-expansion-panel {
    background-color: #FAE6E6;
  }
  &-header {
    display: flex;
    align-items: center;
    &-right {
      display: flex;
      width: 100%;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    article {
      display: flex;
      align-items: center;
    }
    &_avatar {
      margin-right: 21px;
    }
    &_title {
      display: flex;
      flex-shrink: 0;
      flex-direction: column;
      & > h1 {
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #333;
        margin-bottom: 0;
      }
      & > h4 {
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.85;
        letter-spacing: normal;
        text-align: left;
        color: #333;
        margin-bottom: 0;
      }
    }
    &_verified {
      min-width: 81px;
      margin-right: 36px;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.54;
      letter-spacing: 1.69px;
      text-align: left;
      color: #999;
      display: flex;
      img {
        max-width: 14px;
      }
    }
    &_selected {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #CC0000;
      width: 104px;
      text-align: center;
      &--zero {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        color: #333;
        width: 104px;
        text-align: center;
      }
    }
  }

  &-item {
    width: 100%;
    display: flex;
    flex: 1 1 auto;

    &:last-child {
      .expansionPanel-item_label,
      .expansionPanel-item-section {
        border: none;
      }
    }
    &_label {
      width: 90px;
      background-color: #ebcdcd;
      color:#FFF;
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 2px solid #fff;

      &--abcd {
        background-color: #0064FA;
      }

      &--ejk {
        background-color: #00964E;
      }

      &--pyzx {
        background-color: #FA6900;
      }

      &--gmn {
        background-color: #9B00FA;
      }
    }
    &-sections {
      width: 100%;
    }
    &-section, &-section-row {
      display: flex;
      flex-direction: row;
      max-width: 550px;
      padding: 10px 40px 8px 0;
      align-items: center;
      background-color: #fff;
      border-bottom: 2px solid #f4f4f4;

      &_title {
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: center;
        color: #333;
        width: 224px;
        margin: 0;
        text-align: center;
        white-space: pre-wrap;
        word-wrap: break-word;
      }
      &_text {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 42px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        color: #333;
        width: 100%;
        max-width: 250px;
        white-space: pre-wrap;
        word-wrap: break-word;
      }
      &_select {
        &.appSelect {
          max-width: 280px;
          min-width: 280px;
          &::v-deep
            .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
            > .v-input__control
            > .v-input__slot {
            min-height: 42px;
            max-height: 42px;
          }
          &::v-deep .v-select__selection--comma {
            font-size: 16px;
          }
        }
      }
    }
  }
  // mobile
  @media screen and (max-width: 767px) {
    padding: 0;
    &-header {
      article {
        width: 100%;
        justify-content: space-between;
      }
      &-right {
        padding: 5px 0;
      }
      &_selected {
        font-size: 13px;
        width: 100px;

        &--zero {
          width: 100px;
        }
      }
      &__icon {
        margin-right: 7px;
      }

      &_avatar {
        margin-right: 9px;
      }
    }
    &-item {
      &_label {
        width: 37px;
        font-size: 13px;
      }
      &-section, &-section-row {
        padding: 8px;
        justify-content: space-between;
        align-items: center;
        max-width: 100%;
        &_text {
          display: flex;
          justify-content: center;
          width: 170px;
          font-size: 13px;
          white-space: pre-wrap;
          word-wrap: break-word;
        }
        &_title {
          width: auto;
          font-size: 13px;
          text-align: left;
        }
        &_select {
          &.appSelect {
            max-width: 170px;
            min-width: 170px;
            &::v-deep
              .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
              > .v-input__control
              > .v-input__slot {
              min-height: 36px;
              max-height: 36px;
            }
            &::v-deep .v-select__selection--comma {
              font-size: 16px;
              text-align: left;
            }
            &::v-deep .v-select__selections {
              input::placeholder {
                text-align: left;
              }
            }
            &::v-deep .v-input__icon.v-input__icon--append {
              width: 30px;
              .v-icon {
                font-size: 28px;
              }
            }
          }
        }
        &-row{
          flex-direction: column;
          background: #FFF;
          border-bottom: 2px solid #FAE6E6;
          .expansionPanel-item-section_title{
            white-space: nowrap;
            width: 100%;
            margin-bottom: 3px;
          }

          .appSelect.expansionPanel-item-section_select{
            max-width: 100%;
          }

        }
      }
    }
  }
  &::v-deep .v-expansion-panel {
    & .v-expansion-panel {
      &-header {
        padding-right: 10px !important;
      }
    }
  }
  &::v-deep .theme--light.v-expansion-panels .v-expansion-panel {
    background: #f4f4f4;

    &--disabled{
      background: #f4f4f4;
    }
  }
}
</style>
